import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { getMerchandiseInitialVariant } from 'components/Merchandise/merchandiseUtils'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'
import { replace } from 'lib/routing/appRouting'
import { setSearchParamValue } from 'lib/url/searchUrlUtils'

export default function useMerchandiseSelectedVariant(
  variants: Array<App.MerchandiseOfferVariant>,
): [App.MerchandiseOfferVariant, (variant: App.MerchandiseOfferVariant) => void] {
  const location = useLocation()
  const queryParams = useQueryParams()
  const dispatch = useAppDispatch()
  const activeVariant = getMerchandiseInitialVariant(variants, queryParams.get('variantId') ?? undefined)

  const selectVariant = useCallback((variant: App.MerchandiseOfferVariant) => {
    const search = setSearchParamValue(location.search, 'variantId', variant.id)
    dispatch(replace({ pathname: location.pathname, search, hash: location.hash }, location.state))
  }, [dispatch, location])

  return [activeVariant, selectVariant]
}
